import { fetchDocumentType } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    data: [],
    hasError: {},
  },

  mutations: {
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadDocumentTypeData({ commit }) {
      try {
        const response = await fetchDocumentType();
        commit("SET_DATA", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
  },

  getters: {
    docType: (state) => state.data,
  },
};
